import React, { createContext, useState, useContext } from 'react';

const submissionResponseINITIAL = {
  apartmentNumber: "",
  authorityName: "",
  branchCount: "",
  buildingNumber: "",
  categoryId: "",
  cityId: "",
  communeId: "",
  declarationDate: "",
  districtId: "",
  email: "",
  firstName: "",
  krs: "",
  lastName: "",
  name: "",
  phoneNumber: "",
  privilegeDescription: "",
  privilegePercent: "",
  regon: "",
  streetId: "",
  territorialRange: "",
  validityEnd: "",
  validityStart: "",
  voivodeshipId: "",
  website: "",
  zipcode: "",
  "x-class-name": "pl.gov.mpips.kdr.dto.v1_0.SubmissionResponse"
};

const MyContext = createContext();

export const SubmissionProvider = ({ children }) => {
  const [submissionForm, setSubmitResponseValue] = useState(submissionResponseINITIAL);

  return (
    <MyContext.Provider value={{ submissionForm, setSubmitResponseValue }}>
      {children}
    </MyContext.Provider>
  );
};

export const useMyContext = () => useContext(MyContext);